import { request } from '@umijs/max';

export async function loginSubAccount(body: API.SubLoginParams) {
  return request<API.Response<API.SubLoginResult>>('/api/sub-auth/login', {
    method: 'POST',
    data: body,
  });
}

export async function getCurrentSubAccount(options?: { [key: string]: any }) {
  return request<API.Response<API.SubAccountProfile>>('/api/sub-auth/me', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function logoutSubAccount() {
  return request<API.Response>('/api/sub-auth/logout', {
    method: 'POST',
  });
}
